import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResourcesListComponent } from './resources-list.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { MbscModule } from '@mobiscroll/angular';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { ResourceDetailsComponent } from './resource-details.component';
import { EditorModule } from '@tinymce/tinymce-angular';



@NgModule({
  declarations: [
    ResourcesListComponent,
    ResourceDetailsComponent
  ],
  imports: [
      CommonModule
      , FormsModule
      , NgbPaginationModule
      , RouterModule
      , ReactiveFormsModule
      , MbscModule
      , NgxMaskDirective
      , NgxMaskPipe
      , EditorModule
  ]
})
export class SuperAdminResourcesModule { }
